import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import api from '../../../api/api';

export default function FeedPushMusicPicker({ kind, label, ids, labels = {}, onChange, disabled }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [known, setKnown] = useState({});
  const [error, setError] = useState(false);
  useEffect(() => {
    let live = true;
    if (!query.trim()) {
      setResults([]);
      return undefined;
    }
    const timer = setTimeout(async () => {
      try {
        const response = await api.getAuth(`/search/summary?q=${encodeURIComponent(query.trim())}`);
        if (!live) return;
        const items = (response.data?.data?.[kind]?.items || [])
          .map((item) => ({
            id: kind === 'albums' ? item.albumId : item.artistId,
            label: item.title || item.name,
          }))
          .filter((item) => Number.isSafeInteger(item.id) && item.id > 0);
        setResults(items);
        setKnown((previous) => ({
          ...previous,
          ...Object.fromEntries(items.map((item) => [item.id, item.label])),
        }));
        setError(false);
      } catch {
        if (live) setError(true);
      }
    }, 300);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [query, kind]);
  const selected = ids.map((id) => ({ id, label: labels[id] || known[id] || '저장된 음악' }));
  return (
    <Autocomplete
      multiple
      disabled={disabled}
      filterOptions={(items) => items}
      options={[...selected, ...results.filter((item) => !ids.includes(item.id))]}
      value={selected}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      getOptionLabel={(item) => item.label || ''}
      onInputChange={(_event, value, reason) => {
        if (reason === 'input') setQuery(value);
      }}
      onChange={(_event, values) => onChange(values.slice(0, 20).map((item) => item.id))}
      noOptionsText={query ? '등록된 음악을 찾지 못했어요' : '이름으로 검색해주세요'}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={
            error
              ? '검색하지 못했습니다. 다시 입력해주세요.'
              : '관련 음악을 선택하면 취향에 맞는 회원에게 우선 소개합니다.'
          }
        />
      )}
    />
  );
}
